/* eslint-disable react/prop-types */
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Input } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { uid } from "uid"

// ----------------------------------------------------------------------------

function _AgentCodesForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, values, onValueChange } = props

    const codes = values?.agentReservationCodes ?? []

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleLabelChange(code) {
        return (evt) => {
            const index = codes.findIndex(({ code: c }) => c === code)
            if (index > -1) {
                const nc = [...codes]
                nc[index] = { ...nc[index], label: evt.target.value }
                onValueChange("agentReservationCodes")(nc)
            }
        }
    }

    function handleDelete(code) {
        return () => {
            const index = codes.findIndex(({ code: c }) => c === code)
            if (index > -1) {
                const nc = [...codes]
                nc.splice(index, 1)
                onValueChange("agentReservationCodes")(nc)
            }
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            {codes.map(({ label, code }) => {
                return (
                    <div
                        key={code}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            marginBottom: 12,
                        }}
                    >
                        <Input
                            value={label}
                            onChange={handleLabelChange(code)}
                            style={{ maxWidth: 200 }}
                        />
                        <Button
                            shape="circle"
                            type="danger"
                            icon={<DeleteOutlined />}
                            onClick={handleDelete(code)}
                        ></Button>
                    </div>
                )
            })}
            <Button
                type="primary"
                shape="circle"
                onClick={() =>
                    onValueChange("agentReservationCodes")([
                        ...codes,
                        { label: `Codice ${codes.length + 1}`, code: uid(20) },
                    ])
                }
            >
                <PlusOutlined />
            </Button>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AgentCodesForm.propTypes = {
    className: PropTypes.string.isRequired,
}

_AgentCodesForm.defaultProps = {}

// ----------------------------------------------------------------------------

const AgentCodesForm = styled(_AgentCodesForm)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default AgentCodesForm
